import { animate, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { MILESTONE_VIEWER_TOOLTIP_LEGENDS } from '@catalogues';

@Component({
  selector: 'study-gantt-chart-legend',
  templateUrl: './study-gantt-chart-legend.component.html',
  styleUrl: './study-gantt-chart-legend.component.scss',
  animations: [
    trigger('tooltipAnimation', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateY(4px)'
        }),
        animate(
          '200ms ease-out',
          style({
            opacity: 1,
            transform: 'translateY(0)'
          })
        )
      ]),
      transition(':leave', [
        animate(
          '200ms ease-in',
          style({
            opacity: 0,
            transform: 'translateY(4px)'
          })
        )
      ])
    ])
  ]
})
export class StudyGanttChartLegendComponent {
  tooltipVisible = false;
  milestoneViewerTooltipLegends = MILESTONE_VIEWER_TOOLTIP_LEGENDS;

  toggleTooltip() {
    this.tooltipVisible = !this.tooltipVisible;
  }
}
